import styled from "styled-components";

export const Container = styled.div`
	.MuiSvgIcon-root {
		color: #ff0000;
	}
`;
